export const environment = {
    production: false,
    apiUrl: 'https://nfarm.qa.rwsgest.it',
    /** App gestionale Nova: destinazione di "Gestisci" sui piani attivi. */
    managementAppUrl: 'https://gestione.dev.novatellus.com',
    keycloak: {
        url: 'https://auth.dev.novatellus.com',
        realm: 'novatellus',
        clientId: 'ecommerce-oauth2',
    },
} as const;
